module.exports = __webpack_public_path__ + "static/img/son1_active.efd81bf5.png";